import { darkColor, dividerColor } from "@/constants/colors";
import navbarData from "@/constants/navbarData";
import { css } from "@emotion/react";
import { Tooltip } from "react-tooltip";
import { H6 } from "../../Typography";
import OrganizationTypeLink from "../shared/OrganizationTypeLink";
import SportLink from "../shared/SportLink";

interface NavbarDesktopFolderTooltipWhoWeServeProps {}

const NavbarDesktopFolderTooltipWhoWeServe =
  ({}: NavbarDesktopFolderTooltipWhoWeServeProps) => {
    return (
      <Tooltip
        id="who-we-serve-tooltip"
        place="bottom"
        clickable
        opacity={1}
        noArrow
        delayHide={0}
        delayShow={0}
        offset={0}
        style={{ zIndex: 9999 }}
        css={css`
          z-index: 999 !important;
          left: 50% !important;
          transform: translateX(-50%);
          padding: 14px;
          border-radius: 15px !important;
          background-color: #fff !important;
          transition: opacity 0.2s ease-in-out;
          box-shadow: 0px 8px 30px rgba(116, 134, 196, 0.24);
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            padding: 14px;

            @media (min-width: 768px) {
              flex-direction: row;
              align-items: stretch;
              justify-content: flex-start;
            }
          `}
        >
          {/* Organization Types Column */}
          <div
            css={css`
              flex: 1;
              margin-bottom: 24px;
              @media (min-width: 768px) {
                margin-bottom: 0;
                margin-right: 30px;
                padding-right: 30px;
                border-right: 1px solid ${dividerColor};
              }
            `}
          >
            <H6
              css={css`
                color: ${darkColor};
                margin-bottom: 20px;
                font-weight: 700;
                font-size: 24px;
              `}
            >
              Organization Types
            </H6>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                gap: 8px;
              `}
            >
              {navbarData.organizationTypes.map(
                ({ title, href, Icon }, index) => {
                  return (
                    <OrganizationTypeLink
                      key={index}
                      title={title}
                      href={href}
                      Icon={Icon}
                    />
                  );
                }
              )}
            </div>
          </div>

          {/* Mobile separator */}
          <div
            css={css`
              height: 1px;
              background-color: ${dividerColor};
              margin: 10px 0 30px;

              @media (min-width: 768px) {
                display: none;
              }
            `}
          />

          {/* Sports Column */}
          <div
            css={css`
              flex: 1;
              display: flex;
              flex-direction: column;
            `}
          >
            <H6
              css={css`
                color: ${darkColor};
                margin-bottom: 20px;
                font-weight: 700;
                font-size: 24px;
              `}
            >
              Sports
            </H6>
            <div
              css={css`
                display: grid;
                column-gap: 2px;
                row-gap: 8px;
                flex: 1;

                @media (min-width: 768px) {
                  grid-template-columns: repeat(2, 1fr);
                  grid-auto-rows: 1fr;
                }
              `}
            >
              {navbarData.sports.map(({ title, href, Icon }, index) => {
                return (
                  <SportLink
                    key={index}
                    title={title}
                    href={href}
                    Icon={Icon}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </Tooltip>
    );
  };

export default NavbarDesktopFolderTooltipWhoWeServe;
